import { render, staticRenderFns } from "./DetailPesanan.vue?vue&type=template&id=fe0fad56&scoped=true"
import script from "./DetailPesanan.vue?vue&type=script&lang=js"
export * from "./DetailPesanan.vue?vue&type=script&lang=js"
import style0 from "./DetailPesanan.vue?vue&type=style&index=0&id=fe0fad56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0fad56",
  null
  
)

export default component.exports